import React from 'react';
import PropTypes from 'prop-types';

import MessageDisplayBanner from './components/MessageDisplayBanner';
import MessageDisplayModal from './components/MessageDisplayModal';
import './MessageDisplay.css';

const MODAL_SHOWN = 'showFishermanBannerMessage';

export default class MessageDisplay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      showBanner: true,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.toggleBanner = this.toggleBanner.bind(this);
  }

  componentDidMount() {
    const { modalDelay } = this.props;

    if (modalDelay !== false && !this.getModalShownInSession()) {
      setTimeout(this.toggleModal, modalDelay);
    }
  }

  setModalShownInSession(isShown) {
    const { disableCache } = this.props;

    const hasWindowObj = typeof window !== `undefined`;

    if (hasWindowObj && !disableCache) {
      window.sessionStorage.setItem(MODAL_SHOWN, isShown);
    }
  }

  getModalShownInSession() {
    const { disableCache } = this.props;

    // If session cache is disabled, always return false so modal is shown
    if (disableCache) {
      return false;
    }

    const hasWindowObj = typeof window !== `undefined`;

    if (hasWindowObj) {
      return window.sessionStorage.getItem(MODAL_SHOWN);
    }

    return null;
  }

  toggleModal() {
    this.setState(({ showModal }) => {
      // If we are showing the modal, make sure
      // we don't show it again in the same session
      if (showModal) {
        this.setModalShownInSession(true);
      }

      return { showModal: !showModal };
    });
  }

  toggleBanner() {
    this.setState(({ showBanner }) => ({ showBanner: !showBanner }));
  }

  render() {
    const {
      businessName,
      subject,
      content,
      bannerBackgroundColor,
      modalExtra,
      modalButtonText,
      disableModalButton,
    } = this.props;
    const { showModal, showBanner } = this.state;

    return (
      <div className="fm-message-display-container">
        {showBanner && (
          <MessageDisplayBanner
            subject={subject}
            onClick={this.toggleModal}
            onClose={this.toggleBanner}
            backgroundColor={bannerBackgroundColor}
            buttonText={modalButtonText}
            disableButton={disableModalButton}
          />
        )}
        <MessageDisplayModal
          businessName={businessName}
          open={showModal}
          subject={subject}
          content={content}
          onClose={this.toggleModal}
          extra={modalExtra}
        />
      </div>
    );
  }
}

MessageDisplay.propTypes = {
  businessName: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  modalDelay: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  bannerBackgroundColor: PropTypes.string,
  modalButtonText: PropTypes.string,
  modalExtra: PropTypes.element,
  disableCache: PropTypes.bool,
  disableModalButton: PropTypes.bool,
};

MessageDisplay.defaultProps = {
  modalDelay: false,
  bannerBackgroundColor: '',
  modalButtonText: 'See More',
  modalExtra: <div />,
  disableCache: false,
  disableModalButton: false,
};
